<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"

    @cancel="handleCancel"
    cancelText="关闭">
    <video
      v-if="visible"
      ref="myVideo"
      class="video-js vjs-default-skin"
      controls
      preload="auto"
      width="640"
      height="360"
      style="height:100%;width:100%"
      autoplay
    >
      <source :src="window._CONFIG['resourceURL'] + '/school/sys/common/static'+videoPlay" type="video/mp4">
    </video>
  </j-modal>
</template>

<script>
  export default {
    name: 'SchoolActivityVideo',

    data () {
      return {
        title:'活动视频',
        width:800,
        visible: false,
        videoPlay:null,
      }
    },
    methods: {

      edit (record) {
        this.visible=true
        this.videoPlay = record
        // this.$nextTick(()=>{
        //   this.$refs.realForm.edit(record);
        // })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.myVideo.pause();
        // this.$refs.myVideo.dispose()
      },
      handleOk () {

        this.visible = false;
        this.$refs.myVideo.pause();
        // this.$refs.myVideo.dispose()
      },

      handleCancel () {
        this.close()

      }
    }
  }
</script>